import React from 'react';

import { Alert } from '@mui/material';

import { getCreditRefundFrequencyMessage } from '~/consts/refund';

import { useGetCreditRefundFrequency } from '~/hooks/apis/orders/useGetCreditRefundFrequency';

interface Props {
  customerId: string;
}

/**
 * Shown when an agent picks credit as the refund method for a customer who has hit the
 * self-service credit-refund limit. Agents can still refund to credit; this is a heads-up.
 */
export default function CreditRefundFrequencyCaution({ customerId }: Props) {
  const { data } = useGetCreditRefundFrequency(customerId);
  const creditRefunds = data?.result;

  if (!creditRefunds?.blocked) {
    return null;
  }

  return (
    <Alert severity="warning">
      Caution:{' '}
      {getCreditRefundFrequencyMessage(creditRefunds.count, creditRefunds.window_days, creditRefunds.threshold)}
    </Alert>
  );
}
